<div class="example-wrap">
  <kendo-stepper [steps]="[
      { label: 'Authenticate' },
      { label: 'Map Accounts' }
    ]" 
    stepType="full" 
    [currentStep]="0" 
    [linear]="true" 
    [style.width.px]="570">
  </kendo-stepper>
</div>
<br />
<br />
<!-- <div class="content"> -->
<div class="example-wrap">
  <form class="k-form k-form-md" [formGroup]="recordForm">
    <div class="k-form-buttons">
      <h2 class="k-form-title">Add Ingestor Record</h2>
    </div>
    <fieldset class="k-form-fieldset">
      <kendo-formfield>
        <kendo-label labelCssClass="k-form-label" [for]="integration_url" text="Integration Url"></kendo-label>
        <kendo-textbox formControlName="integration_url" #integration_url></kendo-textbox>

        <kendo-formhint>Please enter the integration url</kendo-formhint>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label labelCssClass="k-form-label" [for]="api_key" text="Api Key*"></kendo-label>
        <kendo-textbox formControlName="api_key" #api_key required></kendo-textbox>

        <kendo-formhint>Api Key</kendo-formhint>
        <kendo-formerror>Error: Not valid Api Key</kendo-formerror>
      </kendo-formfield>

      <div class="k-form-field">
        <kendo-label labelCssClass="k-form-label" text="Organization Parent">
        </kendo-label>
        <cyflare-autocomplete
          [baseUrl]="'v1/organization/administrative/organizationautocomplete/'"
          [textField]="'display_text'"
          [valueField]="'id'"
          [placeholder]="'Search parent organization...'"
          [showDropdown]="true"
          [completeOnFocus]="false"
          [cacheTtlMs]="2000000"
          [pageSize]="100"
          [lazyScroll]="true"
          [formGroup]="recordForm"
          [formValueFieldName]="'organization_parent'"
          [defaultItem]="defaultItem"
          [selectedIds]="defaultItem?.id?.toString() || ''"
        ></cyflare-autocomplete>
        <kendo-formhint>Please select the parent organization</kendo-formhint>
      </div>
      <div class="k-form-buttons">
        <button kendoButton (click)="clear()">
          Clear
        </button>
        <button kendoButton themeColor="primary" (click)="save($event)" [disabled]="recordForm.invalid">
          Next
        </button>
      </div>
    </fieldset>
  </form>
</div>
<!-- </div> -->